var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item dots-options",attrs:{"title":'حذف',"href":"javascript:void(0);"},on:{"click":function($event){$event.preventDefault();return _vm.deleteData(_vm.data, _vm.deleteUrl)}}},[_c('i',{staticClass:"flaticon-delete-2"}),_vm._v(" حذف")])
}
var staticRenderFns = []

export { render, staticRenderFns }